import { Badge, Button } from "antd";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { useEffect, useState } from "react";
import { db } from "../../firebase";
import { GoAlert } from "react-icons/go";
import { isDriverMessage } from "../../utils/messageRole";

const NotificationBadge = ({
  fleetId,
  transportOrderId = "",
  userId,
  type = "message",
  buttonSize = "small",
  badgeOffset = { top: "-6px", right: "-6px" },
  onClick,
  children = null,
}) => {
  const [unreadCount, setUnreadCount] = useState(0);
  const [hasIncidents, setHasIncidents] = useState(false);

  useEffect(() => {
    if (type === "message" && !fleetId) {
      console.warn("fleetId is required for messages");
      return;
    }

    if (type === "incident" && (!fleetId || !transportOrderId)) {
      console.warn("Fleet ID and transport order ID are required for incidents");
      return;
    }

    let q;
    let unsubscribe;

    if (type === "message") {
      const isValidTransportOrder = !!transportOrderId?.trim();

      if (userId) {
        q = query(
          collection(db, "fleets", fleetId, "conversations"),
          where("read", "==", false),
          where("userId", "==", userId)
        );
      } else if (isValidTransportOrder) {
        q = query(
          collection(db, "fleets", fleetId, "conversations"),
          where("read", "==", false),
          where("orderId", "==", transportOrderId)
        );
      }

      if (q) {
        unsubscribe = onSnapshot(q, (snapshot) => {
          let nextUnread = 0;
          snapshot.forEach((docSnap) => {
            const data = docSnap.data() || {};
            if (isDriverMessage(data)) {
              nextUnread += 1;
            }
          });
          setUnreadCount(nextUnread);
        });
      }
    }

    if (type === "incident") {
      q = query(
        collection(db, "fleets", fleetId, "incidents"),
        where("transportOrderId", "==", transportOrderId)
      );

      unsubscribe = onSnapshot(q, (snapshot) => {
        let hasAny = false;
        let unread = 0;

        snapshot.forEach((doc) => {
          const data = doc.data();
          if (data) {
            hasAny = true;
            if (data.read === false) {
              unread += 1;
            }
          }
        });

        setHasIncidents(hasAny);
        setUnreadCount(unread);
      });
    }

    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, [fleetId, transportOrderId, userId, type]);

  if (type === "incident" && !hasIncidents) return null;

  const badgeCount = unreadCount > 99 ? "99+" : unreadCount;
  const offset = [
    parseInt(badgeOffset.right || "-6", 10),
    parseInt(badgeOffset.top || "-6", 10),
  ];

  if (type === "message" && children) {
    if (unreadCount <= 0) {
      return children;
    }
    return (
      <Badge count={badgeCount} offset={offset}>
        {children}
      </Badge>
    );
  }

  if (type === "message" && unreadCount <= 0) {
    return null;
  }

  return (
    <span style={{ position: "relative", display: "inline-block" }}>
      {type === "incident" && hasIncidents && (
        <Badge count={badgeCount} offset={offset}>
          <Button
            size={buttonSize}
            type="default"
            icon={<GoAlert size={14} />}
            style={{
              backgroundColor: "var(--chakra-colors-gandolapp-secondary)",
              borderColor: "var(--chakra-colors-gandolapp-secondary)",
              color: "var(--chakra-colors-gandolapp-clean)",
            }}
            onClick={onClick}
          />
        </Badge>
      )}

      {type === "message" && unreadCount > 0 && (
        <Badge count={badgeCount} offset={offset} />
      )}
    </span>
  );
};

export default NotificationBadge;
